import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopProfileBottom728x90Gak from './gak/DesktopProfileBottom728x90';
import DesktopProfileBottom728x90Hashtag from './hashtag/DesktopProfileBottom728x90';
const DesktopProfileBottom728x90 = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopProfileBottom728x90Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileBottom728x90Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopProfileBottom728x90.displayName = 'DesktopProfileBottom728x90';
export default DesktopProfileBottom728x90;
